import React from "react";
import { Link } from "react-router-dom";

import blogHero from "../assets/blog-hero.png";
import blog1 from "../assets/blog1.png";
import blog2 from "../assets/blog2.png";
import blog3 from "../assets/blog3.png";

const Blog = () => {

  const blogs = [
    {
      id: "future-web-dev",
      title: "The Future of Web Development",
      img: blog1,
      desc: "Explore modern technologies shaping the future of websites.",
    },
    {
      id: "ui-ux-importance",
      title: "Why UI/UX Matters More Than Ever",
      img: blog2,
      desc: "Good design is not just beauty — it’s user experience.",
    },
    {
      id: "seo-strategies",
      title: "SEO Strategies That Actually Work",
      img: blog3,
      desc: "Boost your rankings with proven SEO techniques.",
    },
  ];

  return (
    <div className="text-white">

      {/* HERO */}
      <section className="relative h-[80vh] flex items-center justify-center text-center">

        <img
          src={blogHero}
          alt="Blog Hero"
          className="absolute inset-0 w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/80"></div>

        <div className="relative z-10 px-6">
          <h1 className="text-5xl md:text-7xl font-bold">
            Our <span className="text-purple-400">Blog</span>
          </h1>

          <p className="mt-6 text-gray-300 max-w-2xl mx-auto text-lg">
            Insights, trends, and strategies to help your business grow.
          </p>
        </div>
      </section>

      {/* BLOG CARDS */}
      <section className="py-24 px-6 bg-[#0b1a35]">

        <h2 className="text-4xl font-bold text-center mb-16">
          Latest <span className="text-purple-400">Articles</span>
        </h2>

        <div className="grid md:grid-cols-3 gap-10 max-w-6xl mx-auto">

          {blogs.map((blog) => (
            <div
              key={blog.id}
              className="bg-[#112240] rounded-2xl overflow-hidden hover:-translate-y-2 transition"
            >
              <img
                src={blog.img}
                alt={blog.title}
                className="h-56 w-full object-cover"
              />

              <div className="p-6">
                <h3 className="text-xl font-semibold mb-3">
                  {blog.title}
                </h3>

                <p className="text-gray-400 text-sm mb-4">
                  {blog.desc}
                </p>

                {/* FIXED LINK */}
                <Link
                  to={`/blog/${blog.id}`}
                  className="text-purple-400 hover:underline"
                >
                  Read More →
                </Link>
              </div>
            </div>
          ))}

        </div>
      </section>

    </div>
  );
};

export default Blog;